import { render, staticRenderFns } from "./CandidateLogin.vue?vue&type=template&id=4fc348e4&scoped=true"
import script from "./CandidateLogin.vue?vue&type=script&lang=js"
export * from "./CandidateLogin.vue?vue&type=script&lang=js"
import style0 from "./CandidateLogin.vue?vue&type=style&index=0&id=4fc348e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc348e4",
  null
  
)

export default component.exports